/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  visit: VisitDtoModelType;
}

/**
 * VisitUnscheduledDtoBase
 * auto generated base class for the model VisitUnscheduledDtoModel.
 */
export const VisitUnscheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("VisitUnscheduledDto"), "VisitUnscheduledDto"),
    /** Visit that was just unscheduled */
    visit: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => VisitDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitUnscheduledDtoModelSelector extends QueryBuilder {
  visit(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`visit`, VisitDtoModelSelector, builder) }
}
export function selectFromVisitUnscheduledDto() {
  return new VisitUnscheduledDtoModelSelector()
}

export const visitUnscheduledDtoModelPrimitives = selectFromVisitUnscheduledDto()
